// frontend/init/index.js

import './index.css';
import './import_resource_user_views';
import './set-initial-body-classes';
import './save-local-storage-to-cookies';
import './turbolinks-cleanup';
import './query-string-page-refresh';

// split-test: resource_show_modal_view
// disabled during dev of 2165, causing document request / page reload on back button
// import 'components/resources/show/modal-view/setup-resource-show-modal-view';
